export default __webpack_public_path__ + "static/media/ceramic-header.9e3ed472.png";